﻿$.fn.dxCtrlContentEnvoiMailingNom = function custom_dxCtrlContentEnvoiMailingNom(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingnom dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingNom(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingNom = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        $("<div/>").appendTo(container).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Nom de votre mailing",
            value: option.data.nom,
            onValueChanged: function (e) {
                option.data.nom = ((e.value == null) ? "" : e.value)
                option.bddCtrl.getObjet(option.data).mSaveChamp("nom")
                option.onChange()
            }
        })

        $("<div style='padding:10px;font-style:italic;'>Vous pouvez définir un nom pour votre mailing. Ce nom est utilisé dans votre application pour retrouver un mailing. Celui-ci n'apparait pas pour vos destinataires.</div>").appendTo(container)

        if (option.bddCtrl.baseAppli.para.bdd.utilise_classeur) {
            var obj = option.bddCtrl.getObjet(option.data)
            $("<div/>").appendTo(container).dxCtrlSelectClasseur({
                bddCtrl: option.bddCtrl,
                idTable: obj.mGetTable().id_table,
                id: obj.cle(),
                onDemandeSave: function (funcSaved) {
                    var obj = option.bddCtrl.getObjet(option.data)
                    if (obj.cle() == null) {
                        obj.mSave(function () { if (typeof funcSaved != 'undefined') funcSaved(obj.cle()) })
                    } else {
                        if (typeof funcSaved != 'undefined') funcSaved(obj.cle())
                    }
                }
            })
        }
    }

    this.element = function () { return container }

    mConstruit();
}